import { Grid } from '@material-ui/core'
import Autocomplete from '../../../common/AutoComplete';
import Footer from '../../footer/Footer';

const Home = () => {
  return (
    <>
    <div className="text-center mt-10">
      <h1 className="text-4xl font-bold">BeeKeepPal CheckInspect</h1>
      <h3 className="text-xl mt-2">A Handy Tool For Beekeepers</h3>
        <p className="my-2 text-gray-500">Check what the weather conditons will be like for your next beehive inspection.</p>
        
      <Grid container justifyContent="center">
          <Grid item xl={6} lg={6} md={6} className="bg-yellow-500 rounded p-10">
            <Autocomplete />
          </Grid>
      </Grid>    
    </div>
    <Footer />
    </>
  );
}

export default Home;
